var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M24.058 12.321c0-.822-.074-1.642-.22-2.45H12.504v4.639H19a5.48 5.48 0 0 1-2.408 3.613v3.01h3.903a11.65 11.65 0 0 0 3.598-8.812z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#34a853",
    d: "M12.469 24.037a11.56 11.56 0 0 0 7.99-2.904l-3.903-3.01a7.28 7.28 0 0 1-4.087 1.147 7.2 7.2 0 0 1-6.758-4.958H1.673v3.152a12.08 12.08 0 0 0 10.796 6.602z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbc05",
    d: "M5.711 14.326a6.97 6.97 0 0 1 0-4.555V6.67H1.673a11.94 11.94 0 0 0 0 10.766z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea4335",
    d: "M12.469 4.834a6.52 6.52 0 0 1 4.611 1.792l3.464-3.443A11.65 11.65 0 0 0 12.47.067 12.08 12.08 0 0 0 1.673 6.669L5.711 9.77a7.19 7.19 0 0 1 6.758-4.958z"
  })));
};
export { SvgGoogle as ReactComponent };